import React,{ useState, useEffect, useRef } from 'react';

import './router-mark-style.css';

export default function RouterMark(props){
    let {children,width,minHeight = '900px',applicationWidth, style={}} = props;
    const [minWidth,setMinWidth] = useState(0);
    const containerRef = useRef(null);

    useEffect(() => {
        if(width !== 'auto' && width !== minWidth) {
            setMinWidth(width);
        }
    }, [width, minWidth]);

    useEffect(() => {
        const handleResize = () => {
            if(width !== 'auto') {
                setMinWidth(width);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [width]);

    let styleProperties = applicationWidth > 1000 ? { 
         minHeight:minHeight,
         minWidth:minWidth} : null
    styleProperties= {
        ...styleProperties,
        ...style,
    }

    return(
        <div className='RouterMark' ref={containerRef} style={styleProperties}>
            {children}
        </div>
    )
}